import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    row-gap: 45px;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 56px;
    align-items: center;
    justify-content: center;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    align-items: center;
`;

export const Description = styled.div`
    text-wrap: balance;
`;
